import React from 'react';
import { motion } from 'framer-motion';
export function Testimonials() {
  return <section className="bg-secondary py-10 md:py-16 px-4 md:px-12 border-y border-card" data-id="element-290">
      <div className="max-w-4xl mx-auto text-center" data-id="element-291">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-292">
          <div className="text-gold/20 font-playfair text-6xl md:text-8xl leading-none mb-2" data-id="element-293">
            "
          </div>
          <h2 className="font-playfair italic text-2xl md:text-4xl text-warm-white mb-6 leading-snug" data-id="element-294">
            Por primera vez no me dio miedo ver mi cuenta…{' '}
            <span className="text-gold" data-id="element-295">
              sentí que mi cuerpo dejó de reaccionar igual.
            </span>
          </h2>
        </motion.div>
      </div>
    </section>;
}